import { ReactElement } from 'react'
import { useIntl } from 'react-intl'

import { safeFormatMessage } from 'utils/intl'
import { changeTypeMessages } from './messages'
import { IChangeTypeProps } from './types'

export const ChangeType = ({ type }: IChangeTypeProps): ReactElement => {
  const intl = useIntl()

  return <div>{safeFormatMessage({ intl, messages: changeTypeMessages, key: type })}</div>
}
